"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_mixins_1 = require("@hotelplan/components.common.mixins");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const EllipsisWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)(({ isOpen, maxLines }) => isOpen ? {} : Object.assign({}, (0, components_common_mixins_1.cutTextByLinesCount)(maxLines))));
const TextMultilineEllipsis = ({ children, maxLines, isOpen, onReflow, className, }) => {
    const textRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (typeof onReflow === 'function') {
            onReflow({
                clamped: ((_a = textRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) > ((_b = textRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight),
            });
        }
    }, [children]);
    return (react_1.default.createElement(EllipsisWrapper, { isOpen: isOpen || false, maxLines: maxLines, ref: textRef, className: className }, children));
};
exports.default = TextMultilineEllipsis;
//# sourceMappingURL=TextMultilineEllipsis.js.map